import S3Client from 'aws-s3';
import axios from 'axios';
import { format } from 'date-fns';
import * as React from 'react';
import 'whatwg-fetch';
import { IAction, IThunkAction } from '../interfaces';
import { store } from '../store';
import { SubmittedBy, inspectionType } from '../constants/generals';
import { getUserData, parseJwt } from '../services/loginService';
import * as moment from 'moment';
declare var require: any;
const AWS = require('aws-sdk'); 
const uuidv1 = require('uuid/v1');

export function getCurentDate(date, dateFormat = 'MM-DD-YYYY', needDateObj = false) {
    let dateObj;
    if (moment.isMoment(date)) {
        dateObj = date.clone(); // Clone to avoid mutating the original moment object
    }
    // Check if the input is provided and not null or undefined
    else if (date) {
        // If the input is already a Moment.js object, no need for parsing
        dateObj = moment(date);
    } else {
        // If no date is provided, default to the current date
        dateObj = moment();
    }
    // If the provided date is not valid, return 'Invalid Date'
    if (!dateObj.isValid()) {
        return 'Invalid Date';
    }
 
    // Format the date according to the provided format
    let dateRes = dateObj.format(dateFormat);
 
    // Return either the formatted date string or a JavaScript Date object
    return needDateObj ? dateObj.toDate() : dateRes;
}

export function keys(object: Object, callback: Function) {
    for (let key in object) {
        if (object.hasOwnProperty(key)) {
            callback(key);
        }
    }
}

export function isEmpty(obj: Object) {
    if (Object.keys(obj).length <= 0 || !obj) {
        return true;
    }
    return false;
}

export function dispatch<T extends IAction>(action: T | IThunkAction) {
    if ((action as IAction).type) {
        return store.dispatch(action as IAction);
    }
    return store.dispatch<{}, {}>(action as IThunkAction);
}

export function getQuarter(d) {
    d = d || new Date();
    const q = [1, 2, 3, 4];
    return q[Math.floor(d.getMonth() / 3)];
}

export function getQuarterText(q) {
    let suffix = getNumberSuffix(q)
    return `${q}${suffix} Quarter`;
}
export function getNumberSuffix(nPos) { 
    var sSuffix = ""; 
    switch (nPos % 10){
        case 1: sSuffix = (nPos % 100 === 11) ? "th" : "st"; break;
        case 2: sSuffix = (nPos % 100 === 12) ? "th" : "nd"; break;
        case 3: sSuffix = (nPos % 100 === 13) ? "th" : "rd"; break;
        default: sSuffix = "th"; break;
    } 
    return sSuffix;
}
export function getPageTitle(insType, freqType, freqDate, reqFrom) {
    let formTitle = inspectionType(insType);
    let subTitle = reqFrom=='inspection' ? 'Inspection for ': reqFrom=='reportNew'? ' Inspection Report for': 'Form Details';
    let dateTitle = '';
    if(reqFrom!='report') {
        if(freqType=='monthly' ) {
            dateTitle = format(freqDate, 'MMMM YYYY');
        } else if(freqType=='quarterly') {
            dateTitle = `${getQuarterText(getQuarter(new Date(format(freqDate,'YYYY-MM-DD') ) ) )} ${format(freqDate,'YYYY')}` ;
        } else {
            dateTitle = format(freqDate, 'MM/DD/YYYY');
        }
    }
    return `${formTitle} ${subTitle}  ${dateTitle} `;
}
export function splitDate(date: string) {
    const yyyy = date.split('-')[0];
    const mm = date.split('-')[1];
    const dd = date.split('-')[2] || '01';
    return {
        dd, mm, yyyy
    };
}

export function splitDateIE(date: string) {
    const mm = date.split('-')[0];
    const dd = date.split('-')[1];
    const yyyy = date.split('-')[2] || '01';
    return {
        dd, mm, yyyy
    };
}

export function isFormEmpty(values: Object) {
    const notRequired = ['Plants', 'Outfalls', 'Middle_Name'];
    for (const key in values) {
        if (notRequired.indexOf(key) > -1) {
            continue;
        }
        if (values[key].length <= 0) {
            return true;
        }
    }
    return false;
}

declare module 'react' {
    type Provider<T> = React.ComponentType<{
        value: T;
        children?: ReactNode;
    }>;
    type Consumer<T> = ComponentType<{
        children: (value: T) => ReactNode;
        unstable_observedBits?: number;
    }>;
    interface Context<T> {
        Provider: Provider<T>;
        Consumer: Consumer<T>;
    }
    function createContext<T>(defaultValue: T, calculateChangedBits?: (prev: T, next: T) => number): Context<T>;
}

export const ModelContext = React.createContext('');

Array.prototype.insert = function (index) {
    this.splice.apply(this, [index, 0].concat(
        Array.prototype.slice.call(arguments, 1)));
    return this;
};

export function isAdmin(Access_Level) {
    return Access_Level === 'L1';
}

export function getCurrentUserUUID() {
    return store.getState().login.get('UniqueId');
}

export function marshallAnswers(values, formType?) { 
    const answer: {
        quesNum: number;
        answer: string;
    }[] = [];
    let missedKey = 0;
    for (const key in values) { 
        if (key === '0' || key === 'deletedImages') {
            //missedKey++;
            continue;
        }
        if(formType && ( (formType=='MonthlySW' && Number(key)>60) || (formType=='MonthlySpillLogs' && Number(key)>4) )) {
            continue;
        }
        //let quesNum = Number(key)-missedKey; 
        answer.push({
            quesNum: Number(key),
            answer:
                (values[key] !== null && typeof (values[key]) === 'boolean') ?
                    (values[key] === true ? 'Yes' : 'No') :
                    values[key]
        });
    }
    answer.sort((a, b) => {
        return a.quesNum - b.quesNum;
    });
    return answer;
}
export function marshallAnswersPlantPreventive(values) {
    const answer: {
        quesNum: number;
        answer: string;
    }[] = [];
    for (const key in values) {
        if (key === '0') {
            continue;
        }
        answer.push({
            quesNum: Number(key),
            answer:
                (values[key] !== null) ?
                    ((values[key]) === 'N*' ? 'Ok' : (values[key]) !== 'Y*' && key !== '54'
                        ? `Needs work-${values[key]}` : values[key])
                    : values[key]
        });
    }
    answer.sort((a, b) => {
        return a.quesNum - b.quesNum;
    });
    return answer;
}
export function marshallChecklistData(data) {
    const answersData = [];
    let date = '';
    let flagged = false;
    let formId = '';
    let flag = true;
    for (const key in data) { 
        flag = false;
        date = key;
        const sURL = data[key].Signature_URL;
        const aDate = data[key].Date;
        if (data[key] instanceof Object) {
            for (const key1 in data[key]) {
                if (key1.toLowerCase() === 'flagged') {
                    flagged = data[key][key1];
                }
                if (data[key][key1] instanceof Object) {
                    const answers = [];
                    flag = true;
                    for (const key2 in data[key][key1]) {
                        if (key2 !== '61') {
                            answers.push({
                                answer: {
                                    quesNum: key2,
                                    answer: data[key][key1][key2],
                                    date,
                                    flagged,
                                }
                            });
                        }
                    }
                    answers.push({
                        answer: {
                            quesNum: '61',
                            answer: aDate,
                            date,
                            flagged,
                        }
                    });
                    answers.push({
                        answer: {
                            quesNum: '62',
                            answer: sURL,
                            date,
                            flagged,
                        }
                    });
                    answersData.push({ month: key, data: answers, entryDate: data[key]['Date'] });
                }
            }
        }
    }
    return answersData;
}

export async function uploadImageToS3(file, filename, dirName) {
    AWS.config.update({
        accessKeyId: 'AKIA47N26QZ4FZMVBMMY',
        secretAccessKey: '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',
        //accessKeyId: 'AKIAI3PI3RO6NAQ4MIFQ',
        //secretAccessKey: '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',
    });
    AWS.config.region = 'us-west-2';
    const s3 = new AWS.S3();

    const myBucketName = 'enviroconnect';
    const params = {
        Bucket: myBucketName,
        // Key: `notificationFiles/${name}.${fileExtension}`,
        Key: `${dirName}/${filename}`,
        Body: file,
        ContentType: file.type,
        ACL: 'public-read'
    };
    return s3.putObject(params, function (err, data) {
        if (err) {
            throw err;
        } else {
            return true;
        }
    });
}

// export async function uploadImageToS3(file, filename, dirName) {

//     const config = {
//         bucketName: 'enviroconnect', // 'harish-soni-1',
//         dirName: dirName,  //  'testing', /* optional */
//         region: 'us-west-2', // 'us-east-1',
//         accessKeyId: 'AKIAI3PI3RO6NAQ4MIFQ',
//         secretAccessKey: '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',
//     };
//     file.filename = filename;
//     return S3Client
//         .uploadFile(file, config)
//         .then(data => { return data; })
//         .catch(err => console.error(err, 'asdasdsa'));

// }

export async function deleteImageFromS3(file, dirName) {

    const config = {
        bucketName: 'enviroconnect', // 'harish-soni-1',
        dirName: dirName,  //  'testing', /* optional */
        region: 'us-west-2', // 'us-east-1',
        accessKeyId: 'AKIAI3PI3RO6NAQ4MIFQ',
        secretAccessKey: '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',
    };

    return S3Client
        .deleteFile(file, config)
        .then(data => { return data; })
        .catch(err => console.error(err));

}

export function base64ToFile(datURL, filename) {
    const arr = datURL.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]);
    let n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return { file: new Blob([u8arr], { type: 'image/png' }), filename };
}

// export async function base64ToFile(dataURL, fileName) {
//     const arr = dataURL.split(',');
//     const mime = arr[0].match(/:(.*?);/)[1];
//     return (fetch(dataURL)
//         .then(function (result) {
//             return result.arrayBuffer();
//         })).then(function (buffer) {
//             return new File([buffer], fileName, { type: mime });
//         }).catch(function () {
//             console.error('Error in Fetch');
//         });
// }

export async function asyncForEach(array: any[], callback?: Function) {
    for (let i = 0; i < array.length; i++) {
        await callback(array[i], i, array);
    }
}

export function compressBase64Image(base64String: string, callback) {
    const canvas = document.createElement('canvas');
    let image64 = '';
    const canvasContext = canvas.getContext('2d');
    canvas.height = 75;
    canvas.width = 90;
    const image = new Image();
    image.src = base64String;
    image.onload = (e) => {
        canvasContext.drawImage(image, 0, 0, image.width, image.height,
            0, 0, canvas.width, canvas.height);
        image64 = canvas.toDataURL();
        callback(image64);
    };
}


declare const Buffer: any;
export function getBase64(url) {
    return axios.get(url, {
        responseType: 'arraybuffer'
    }).then(response => new Buffer(response.data, 'binary').toString('base64'));
}

export function formatDate(date) {
    return format(new Date(date), 'YYYY-MM-DD');
}

export function objectToArray(obj) {
    let AnswerData = Object.keys(obj).map(key => {
        return obj[key];
    });
    return AnswerData;
}

export function formatDateToUS(date: string) {
    if (date) {
        const splitDate = date.split('-');
        return `${splitDate[1]}/${splitDate[2]}/${splitDate[0]}`;
    }
    return '';
}

export function getBase64Image(img) {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    const dataURL = canvas.toDataURL('image/png');
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
}

export function toDataUrl(url, callback) {
    let xhr = new XMLHttpRequest();
    xhr.onload = function () {
        let reader = new FileReader();
        reader.onloadend = function () {
            callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
}

export function marshallFormDetails(instance, index: number, datePlant?) {
    if (instance.question !== SubmittedBy) {
        const newInstance = {
            answer: instance.Answer,
            question: instance.Question,
            quesNum: index + 1,
            flaggedQuestion: instance.FlaggedQuestion > 0,
            completed: (instance.Completed || -1) > 0,
            completedBy: instance.CompletedBy || '',
            followUpComments: instance.Comment || '',
            dateCompleted: instance.CompletedDate && format(instance.CompletedDate, 'MM/DD/YYYY')
        };
        return newInstance;
    }
    return instance;
}

export function getCurrentUserAccessLevel() {
    const userToken = getUserData().token;
    const accessLevel = parseJwt(userToken).Access_Level;
    return accessLevel;
}

export function checkAnswerForYesOrNo(answer) {
    return typeof answer === 'boolean' || typeof answer === 'string' ? answer : null;
}

export function detailsReportPagePdfMake(data) {
    let storeCustomlabel = '';
    let values = [{}];
    let notes = [];
    values = [{
        table: {
            widths: ['50%', '30%', '20%'],
            headerRows: 1,
            body: [
                [{ text: 'Inspection Area', fontSize: 8, alignment: 'center', bold: true },
                { text: 'Needs Work', fontSize: 8, alignment: 'center', bold: true },
                { text: 'OK', fontSize: 8, alignment: 'center', bold: true },
                ],
            ],
        }
    }];
    data.map((value, index) => {
        if (value.Questiontype === 'YesNoTypeComment' || value.Questiontype === 'subQuestions') {
            values.push({
                table: {
                    widths: ['50%', '30%', '20%'],
                    headerRows: 1,
                    body: [
                        [{ text: `${value.customLabel}) ${value.question}`, fontSize: 8 },
                        value.answer !== 'Ok' && value.answer !== 'UnAnswered' ?
                            /*tslint:disable-next-line*/
                            {
                                image: 'data:image/jpeg;base64,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'
                                , width: 7, height: 7, alignment: 'center'
                            } : { text: '' }
                            , value.answer === 'Ok' ?
                            /*tslint:disable-next-line*/
                            {
                                image: 'data:image/jpeg;base64,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'

                                , width: 7, height: 7, alignment: 'center'
                            } : { text: '' }
                        ],
                    ],
                }
            });
        } else if (value.Questiontype === 'title') {
            values.push({
                table: {
                    widths: ['100%'],
                    headerRows: 1,
                    body: [
                        [
                            {
                                text: `${value.customLabel || ''} ${value.question}`,
                                fontSize: 8, bold: true, alignment: 'center'
                            },
                        ]
                    ],
                },
            });
        } else if (value.Questiontype === 'headingForSubsections') {
            values.push({
                table: {
                    widths: ['100%'],
                    headerRows: 1,
                    body: [
                        [
                            { text: `${value.customLabel || ''}) ${value.question}`, fontSize: 8 },
                        ]
                    ],
                },
            });
        }
        if (value.Questiontype === 'headingForSubsections') {
            storeCustomlabel = value.customLabel;

        } else if (value.Questiontype === 'title') {
            storeCustomlabel = '';
        }
        if (value.answer.indexOf('Needs work-') > -1) {
            if (value.Questiontype === 'YesNoTypeComment') {
                notes.push(
                    `${value.customLabel}: ${value.answer} \t`
                );
            } else if (value.Questiontype === 'subQuestions') {
                notes.push(
                    `${storeCustomlabel}.${value.customLabel}: ${value.answer} \t`
                );
            }
        }
    });
    return { values, notes };
}
export function getFormattedDate(date = new Date()) {
    date.setDate(date.getDate() + 1);
    return {
        formatted: format(date, 'YYYY-MM-DD'),
        date
    };
}
export function getImageData(file: any, quesType: string) {  
    const fileName = `${uuidv1()}.png`;
    //const name = new Date().getTime().toString();
    return {'name': fileName, 'quesType': quesType, 'file': file}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/generalUtils.tsx